import type { TaskStatusResponse } from '../../types';

const COPY: Record<string, string> = {
  pending: '任务已进入队列，正在准备评测环境',
  processing: '正在分析文章结构、证据与 AI 引用潜力',
  success: '评测完成，报告已生成',
  partial_failed: '部分文章已完成，另一篇可在报告中重试',
  failed: '评测未完成，可稍后重试',
  timeout: '本次评测超时，可在报告中重试'
};
export function GenerationStatus({
  task,
  elapsed,
  error,
  onViewReports
}: {
  task: TaskStatusResponse | null;
  elapsed: number;
  error?: string;
  onViewReports: () => void;
}) {
  if (!task && !error) return null;
  const terminal = task && ['success', 'partial_failed', 'failed', 'timeout'].includes(task.status);
  const timedCopy =
    elapsed >= 30
      ? '评测时间稍长，你可以先去“我的报告”，完成后会保留结果。'
      : elapsed >= 10
        ? '复杂文章需要更多分析时间，请耐心等待。'
        : '通常需要数秒到一分钟，请勿重复提交。';
  return (
    <section className={`generation-status ${error ? 'is-error' : ''}`} aria-live="polite">
      <div className="status-indicator">{terminal ? '✓' : <span className="spinner" />}</div>
      <div>
        <h3>{error ? '状态获取暂时失败' : COPY[task?.status || 'pending']}</h3>
        <p>{error || (terminal ? `任务状态：${task?.status}` : timedCopy)}</p>
        {task?.articles?.length ? (
          <div className="child-statuses">
            {task.articles.map((item) => (
              <span key={item.id}>
                文章 {item.slot}：{item.status}
              </span>
            ))}
          </div>
        ) : null}
      </div>
      <button className="btn secondary" onClick={onViewReports}>
        查看我的报告
      </button>
    </section>
  );
}
